import React from "react";
import Tooltip from "../../utils/tooltip";

function InvitationCodeSection({
  language,
  IS_FREE,
  invitationCode,
  handleInvitationCodeChange,
  invitationError,
  invitationSuccess,
}) {
  const t = {
    EN: {
      invitationCode: "Invitation Code",
      title: "Enter your invitation code",
      placeholder:
        "Paste your invitation code. If you don't have one, leave the field blank.",
      tooltip:
        "Copy and paste the invitation code provided by the organizers. If you don't have an invitation code, you can continue the process and pay at the end.",
    },
    ES: {
      invitationCode: "Código de invitación",
      title: "Ingresá tu código de invitación",
      placeholder:
        "Pegá tu código de invitación. Si no tenés uno, dejá el campo vacío.",
      tooltip:
        "Copiá y pegá el código de invitación proporcionado por la organización. Si no tenés un código de invitación podés continuar el proceso y pagar al finalizar.",
    },
  };

  if (IS_FREE) return null;

  return (
    <div className="containerFlex">
      <label style={{width: "100%"}}>
        {t[language].invitationCode}
        <Tooltip text={t[language].tooltip} />
      </label>
      <input
        className="match"
        type="text"
        name="invitation_code"
        value={invitationCode}
        onChange={handleInvitationCodeChange}
        title={t[language].title}
        placeholder={t[language].placeholder}
      />

      {invitationError && <span className="required">{invitationError}</span>}
      {invitationSuccess && <span className="success">{invitationSuccess}</span>}
    </div>
  );
}

export default InvitationCodeSection;
